export default function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /Users/guillaumeluce/Documents/ocean/web/app/themes/akyos-sage/node_modules/swiper/core/classes/removeClasses.js
// module id = 79
// module chunks = 0